// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.total-bg {
  position: fixed;
  top: 0px;
  bottom: 0px;
  height: 100%;
  width: 100%;
}

.error-card {
  margin: auto;
  width: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
}
.error-card .box {
  color: #4c6a82;
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  background: #fff;
}
.error-card .box h2 {
  font-weight: 600;
  letter-spacing: 4px;
}
.error-card .box figure img {
  max-width: 100%;
}
.error-card .box p {
  font-size: 17px;
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
@keyframes headShake {
  0% {
    transform: translateX(0);
  }
  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }
  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }
  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }
  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }
  50% {
    transform: translateX(0);
  }
}
.animated {
  animation-timing-function: ease-in-out;
  animation-name: headShake;
  animation-duration: 1s;
  animation-duration: var(1s);
  animation-fill-mode: both;
}`, "",{"version":3,"sources":["webpack://./src/app/common/error-page/error-page.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EACI,YAAA;EACA,UAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AAEJ;AADI;EACI,cAAA;EACA,8FAAA;EACA,gBAAA;AAGR;AAFQ;EACI,gBAAA;EACA,mBAAA;AAIZ;AADY;EACI,eAAA;AAGhB;AAAQ;EACI,eAAA;EACA,8FAAA;AAEZ;AA8BA;EACC;IAEC,wBAAA;EADA;EAGD;IAEC,0CAAA;EADA;EAGD;IAEC,wCAAA;EADA;EAGD;IAEC,0CAAA;EADA;EAGD;IAEC,wCAAA;EADA;EAGD;IAEC,wBAAA;EADA;AACF;AAIA;EAEI,sCAAA;EAEA,yBAAA;EAEH,sBAAA;EAEA,2BAAA;EAEA,yBAAA;AAFD","sourcesContent":[".total-bg{\r\n    position: fixed;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n.error-card{\r\n    margin: auto;\r\n    width: 50%;\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    text-align: center;\r\n    .box{\r\n        color: #4c6a82;\r\n        font-family: \"SF Pro Text\",\"SF Pro Icons\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;\r\n        background: #fff;\r\n        h2 {\r\n            font-weight: 600;\r\n            letter-spacing: 4px;\r\n        }\r\n        figure {\r\n            img {\r\n                max-width: 100%;\r\n            }\r\n        }\r\n        p {\r\n            font-size: 17px;\r\n            font-family: \"SF Pro Text\",\"SF Pro Icons\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;\r\n        }\r\n    }   \r\n}\r\n\r\n@-webkit-keyframes headShake {\r\n\t0% {\r\n\t\t-webkit-transform: translateX(0);\r\n\t\ttransform: translateX(0)\r\n\t}\r\n\t6.5% {\r\n\t\t-webkit-transform: translateX(-6px) rotateY(-9deg);\r\n\t\ttransform: translateX(-6px) rotateY(-9deg)\r\n\t}\r\n\t18.5% {\r\n\t\t-webkit-transform: translateX(5px) rotateY(7deg);\r\n\t\ttransform: translateX(5px) rotateY(7deg)\r\n\t}\r\n\t31.5% {\r\n\t\t-webkit-transform: translateX(-3px) rotateY(-5deg);\r\n\t\ttransform: translateX(-3px) rotateY(-5deg)\r\n\t}\r\n\t43.5% {\r\n\t\t-webkit-transform: translateX(2px) rotateY(3deg);\r\n\t\ttransform: translateX(2px) rotateY(3deg)\r\n\t}\r\n\t50% {\r\n\t\t-webkit-transform: translateX(0);\r\n\t\ttransform: translateX(0)\r\n\t}\r\n}\r\n\r\n@keyframes headShake {\r\n\t0% {\r\n\t\t-webkit-transform: translateX(0);\r\n\t\ttransform: translateX(0)\r\n\t}\r\n\t6.5% {\r\n\t\t-webkit-transform: translateX(-6px) rotateY(-9deg);\r\n\t\ttransform: translateX(-6px) rotateY(-9deg)\r\n\t}\r\n\t18.5% {\r\n\t\t-webkit-transform: translateX(5px) rotateY(7deg);\r\n\t\ttransform: translateX(5px) rotateY(7deg)\r\n\t}\r\n\t31.5% {\r\n\t\t-webkit-transform: translateX(-3px) rotateY(-5deg);\r\n\t\ttransform: translateX(-3px) rotateY(-5deg)\r\n\t}\r\n\t43.5% {\r\n\t\t-webkit-transform: translateX(2px) rotateY(3deg);\r\n\t\ttransform: translateX(2px) rotateY(3deg)\r\n\t}\r\n\t50% {\r\n\t\t-webkit-transform: translateX(0);\r\n\t\ttransform: translateX(0)\r\n\t}\r\n}\r\n\r\n.animated {\r\n    -webkit-animation-timing-function: ease-in-out;\r\n    animation-timing-function: ease-in-out;\r\n    -webkit-animation-name: headShake;\r\n    animation-name: headShake;\r\n    -webkit-animation-duration: 1s;\r\n\tanimation-duration: 1s;\r\n\t-webkit-animation-duration: var(1s);\r\n\tanimation-duration: var(1s);\r\n\t-webkit-animation-fill-mode: both;\r\n\tanimation-fill-mode: both\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
